// import {
//   P
// } from 'gsap'

import TweenMax from 'gsap/TweenMax'

const switchStates = {
  fishLeft: false,
  fishRight: false,
}

// Scene

TweenMax.to('.stage__boat', 3, {
  ease: Power1.easeInOut,
  y: 10,
  yoyo: true,
  repeat: -1
})

TweenMax.to('.stage__clouds', 90, {
  ease: Power0.easeNone,
  x: 1920 * 2,
  repeat: -1
})

TweenMax.to('.stage__clouds-2', 90, {
  ease: Power0.easeNone,
  x: 1920 * 2,
  delay: 45,
  repeat: -1
})

TweenMax.to('.stage__fish-left', 4, {
  ease: Power1.easeInOut,
  x: 40,
  yoyo: true,
  repeat: -1,
  onRepeatParams: ['{self}'],
  onRepeat: self => {
    switchStates.fishLeft = !switchStates.fishLeft

    TweenMax.set(self.target, {
      scaleX: switchStates.fishLeft ? -1 : 1,
      transformOrigin: 'center'
    })
  }
})

TweenMax.set('.stage__fish-right', {
  scaleX: switchStates.fishRight ? 1 : -1,
  transformOrigin: 'center'
})

TweenMax.to('.stage__fish-right', 5, {
  ease: Power1.easeInOut,
  x: 40,
  yoyo: true,
  repeat: -1,
  onRepeatParams: ['{self}'],
  onRepeat: self => {
    switchStates.fishRight = !switchStates.fishRight

    TweenMax.set(self.target, {
      scaleX: switchStates.fishRight ? 1 : -1,
      transformOrigin: 'center'
    })
  }
})

TweenMax.to('#mill--spokes', 5, {
  ease: Power0.easeNone,
  rotation: 360,
  transformOrigin: 'center',
  repeat: -1
})

TweenMax.fromTo('.stage__water-front', 4, {
  ease: Power0.easeNone,
  x: -66,
  repeat: -1
}, {
  ease: Power0.easeNone,
  x: 0,
  repeat: -1
})

TweenMax.fromTo('.stage__water-back', 3, {
  ease: Power0.easeNone,
  x: -66,
  repeat: -1
}, {
  ease: Power0.easeNone,
  x: 0,
  repeat: -1
})

const shark = new TimelineMax({
  repeat: -1
})

shark.to('.stage__shark', 2, {
  y: 10,
  transformOrigin: 'center',
}).to('.stage__shark', 4, {
  y: -10,
  transformOrigin: 'center',
}).to('.stage__shark', 0.5, {
  y: 0,
  transformOrigin: 'center',
}).to('.stage__shark', 0.125, {
  x: 0,
  y: -5,
  rotation: 5,
  transformOrigin: 'center',
}).to('.stage__shark', 0.125, {
  x: -5,
  y: 0,
  rotation: -5,
  transformOrigin: 'center',
}).to('.stage__shark', 0.125, {
  x: 0,
  y: 5,
  rotation: 5,
  transformOrigin: 'center',
}).to('.stage__shark', 0.125, {
  x: 5,
  y: 0,
  rotation: -5,
  transformOrigin: 'center',
}).to('.stage__shark', 0.125, {
  x: 0,
  y: 0,
  rotation: 0,
  transformOrigin: 'center',
})

// UI

TweenMax.to('.button-icon-wrapper', 1, {
  ease: Power1.easeInOut,
  scale: 1.2,
  transformOrigin: 'center',
  yoyo: true,
  repeat: -1
})
